import React from 'react'
import SbEditable from 'storyblok-react'
import DealerSearch from '../modules/DealerSearch'

const DealerSearchBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="dealer-search-block">
        <div className="dealer-search-block-container">
          <DealerSearch />
        </div>
      </section>
    </SbEditable>
  )
}

export default DealerSearchBlock
